import { authGet } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import { SlackAppIntegrationGetResponse } from "@pages/settings/types";

export const fetchSlackAppIntegration = (deploymentId: string) => {
  return authGet<SlackAppIntegrationGetResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/slack/installations`
  );
};
